<template>
    <div class="library-container">
        <SuperAdminSchoolHead>
            <template v-slot:title>{{ $t('library') }}</template>
        </SuperAdminSchoolHead>

        <SmartTable :schools="libraries" :page-size="libraries.length" :total-elements="4" :totalPages="1"
                    :current-page="1">
            <template v-slot:firstItem>
                <SmartSelect>{{ $t('school') }} <v-icon>$chevronDown</v-icon></SmartSelect>
                <SmartSelect>{{ $t('class') }} <v-icon>$chevronDown</v-icon></SmartSelect>
                <SmartSelect>{{ $t('course') }} <v-icon>$chevronDown</v-icon></SmartSelect>
            </template>
            <template v-slot:head>
                <th>{{ $t('book') }}</th>
                <th>{{ $t('author') }}</th>
                <th>{{ $t('inReserve') }}</th>
                <th>{{ $t('requestDate') }}</th>
                <th>{{ $t('quantity') }}</th>
                <th>{{ $t('notEnough') }}</th>
                <th>{{ $t('got') }}</th>
                <th>{{ $t('onWay') }}</th>
            </template>

            <template v-slot:body="{ item }">
                <td>{{ item['book'] }}</td>
                <td>{{ item['author'] }}</td>
                <td>{{ item['reserved'] }}</td>
                <td>{{ item['date'] }}</td>
                <td>{{ item['quantity'] }}</td>
                <td>{{ item['notEnough'] }}</td>
                <td>{{ item['received'] }}</td>
                <td>{{ item['onWay'] }}</td>
                <td><img src="../../assets/images/icons/pen.svg" alt=""></td>
            </template>
        </SmartTable>
    </div>
</template>

<script>
import SuperAdminSchoolHead from '@/components/super-admin/schools/SuperAdminSchoolHead'
import SmartTable from '@/components/table/SmartTable'
import SmartButton from '@/components/button/SmartButton'
import SmartSearchInput from '@/components/input/SmartSearchInput'
import SmartBtn2 from '@/components/button/SmartBtn2'
import SmartSelect from '@/components/select/SmartSelect'

export default {
  components: {
    SmartSelect,
    SmartBtn2,
    SmartSearchInput,
    SmartButton,
    SuperAdminSchoolHead,
    SmartTable
  },

  data () {
    return {
      libraries: [
        {
          book: 'Химия',
          author: 'Иван Петров',
          reserved: 12,
          date: '25.08.2020',
          quantity: 400,
          notEnough: 2,
          received: 3554,
          onWay: 2559
        },
        {
          book: 'Математика',
          author: 'Хадижа Жанболотова',
          reserved: 12,
          date: '25.08.2020',
          quantity: 400,
          notEnough: 2,
          received: 3554,
          onWay: 2559
        },
        {
          book: 'География',
          author: 'Аселя Мухтарова',
          reserved: 12,
          date: '25.08.2020',
          quantity: 400,
          notEnough: 2,
          received: 3554,
          onWay: 2559
        },
        {
          book: 'История',
          author: 'Любовь Аксенова',
          reserved: 12,
          date: '25.08.2020',
          quantity: 400,
          notEnough: 2,
          received: 3554,
          onWay: 2559
        }
      ]
    }
  }
}
</script>
